export default "__VITE_ASSET__9ebcac46__"